/** YouTube widget messages from an embed that already has enablejsapi=1. */

export function parseYouTubeWidgetMessage(data, widgetId) {
  let message = data;
  if (typeof message === 'string') {
    try {
      message = JSON.parse(message);
    } catch {
      return null;
    }
  }
  if (!message || message.channel !== 'widget') return null;
  if (widgetId && message.id && message.id !== widgetId) return null;
  const info = message.info;
  const currentTime = info && typeof info === 'object' ? Number(info.currentTime) : NaN;
  const state = message.event === 'onStateChange'
    ? Number(info)
    : (info && typeof info === 'object' ? Number(info.playerState) : NaN);
  return {
    event: message.event || '',
    state: Number.isFinite(state) ? state : null,
    currentTime: Number.isFinite(currentTime) ? currentTime : null,
  };
}

function postWidget(iframe, widgetId, payload) {
  try {
    iframe.contentWindow?.postMessage(JSON.stringify({
      ...payload,
      id: widgetId,
      channel: 'widget',
    }), '*');
  } catch {
    /* frame not ready */
  }
}

/**
 * Read playback time and pause from the visible embed without replacing it.
 * @param {HTMLIFrameElement} iframe
 */
export function attachYouTubeWidget(iframe) {
  const widgetId = iframe.id || `board-yt-${Math.random().toString(36).slice(2, 8)}`;
  iframe.id = widgetId;
  let seconds = 0;
  let played = false;
  const pauseHandlers = new Set();

  const onMessage = event => {
    if (event.source !== iframe.contentWindow) return;
    const message = parseYouTubeWidgetMessage(event.data, widgetId);
    if (!message) return;
    if (message.currentTime != null) seconds = message.currentTime;
    if (message.state === 1) played = true;
    if (message.state === 2 && played) {
      pauseHandlers.forEach(handler => handler(seconds));
    }
  };

  const listen = () => postWidget(iframe, widgetId, { event: 'listening' });
  window.addEventListener('message', onMessage);
  iframe.addEventListener('load', listen);
  listen();
  const keepAlive = setInterval(listen, 1000);

  return {
    hasPlayed: () => played,
    getCurrentTime() {
      return new Promise(resolve => {
        let settled = false;
        const finish = value => {
          if (settled) return;
          settled = true;
          window.removeEventListener('message', onReply);
          clearTimeout(timer);
          const next = Number(value);
          resolve(Number.isFinite(next) && next > 0 ? next : seconds);
        };
        const onReply = event => {
          if (event.source !== iframe.contentWindow) return;
          const message = parseYouTubeWidgetMessage(event.data, widgetId);
          if (message?.currentTime != null) finish(message.currentTime);
        };
        window.addEventListener('message', onReply);
        const timer = setTimeout(() => finish(seconds), 700);
        postWidget(iframe, widgetId, { event: 'command', func: 'getCurrentTime', args: [] });
      });
    },
    onPause(handler) {
      pauseHandlers.add(handler);
    },
    destroy() {
      clearInterval(keepAlive);
      iframe.removeEventListener('load', listen);
      window.removeEventListener('message', onMessage);
      pauseHandlers.clear();
    },
  };
}
